"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryResultsRpcResponseImplementation = exports.QueryResultsRpcRequestImplementation = void 0;
const core_1 = require("./core");
class QueryResultsRpcRequestImplementation extends core_1.BaseRpcRequest {
    constructor() {
        super(...arguments);
        this.method = "queryResults";
    }
}
exports.QueryResultsRpcRequestImplementation = QueryResultsRpcRequestImplementation;
class QueryResultsRpcResponseImplementation extends core_1.BaseRpcResponse {
}
exports.QueryResultsRpcResponseImplementation = QueryResultsRpcResponseImplementation;
//# sourceMappingURL=query-results.type.js.map